import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class BlockSyncService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async waitForBlockSync(blockNumber, wait) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/block-sync/${blockNumber}?wait=${wait}`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
